var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCegidLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "40px",
    viewBox: "0 0 100 40",
    style: {
      enableBackground: "new 0 0 100 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0046FE;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,24.8c-3.1,0-5.3-2.5-5.3-5.8c0-3.3,2.2-5.8,5.3-5.8c3.1,0,5.3,2.4,5.3,5.8C58.3,22.3,56,24.8,53,24.8  M58.3,8.7v2.2h-0.8l-0.1-0.1c-1.2-1.3-2.7-2.6-5.8-2.6c-5.2,0-9.3,4.7-9.3,10.8c0,6.1,4.2,10.8,9.6,10.8c3.1,0,4.6-1.3,5.5-2.4 l0.1-0.1h0.8v4.2c0,1.9-1.5,3.4-3.4,3.4h-7V40h7.7c4.4,0,8-3.6,8-8V8.7H58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,30.2c-6.2,0-10.7-4.5-10.7-10.8c0-6.2,4.5-10.8,10.5-10.8c6,0,10.3,4.4,10.3,10.8v1.2H24l0,0.3 c0,2.8,2.1,4.7,5.1,4.7c2.2,0,3.9-0.9,4.7-2.5l4.7,1.1C37.2,28,33.8,30.2,29.2,30.2 M29.1,12.9c-2.9,0-4.7,2-5,4l0,0.3h10l0-0.3 C33.7,14.6,31.6,12.9,29.1,12.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.1,9.6h5.3v20h-5.3V9.6z M70.8,6.2c-1.8,0-3.2-1.3-3.2-3.1C67.6,1.3,69,0,70.8,0C72.6,0,74,1.4,74,3.1 C74,4.9,72.6,6.2,70.8,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.4,30.3c-5.4,0-9.6-4.8-9.6-10.8c0-6,4.1-10.8,9.3-10.8c2.5,0,4.4,0.9,5.8,2.6l0.1,0.1h0.8V0.3h5.3v29.5 h-5.3v-2h-0.9l-0.1,0.1C90.7,29.5,88.8,30.3,86.4,30.3 M87.5,13.7c-3.1,0-5.3,2.4-5.3,5.8c0,3.4,2.3,5.8,5.4,5.8 c3,0,5.3-2.5,5.3-5.8C92.9,16.1,90.7,13.7,87.5,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,30.1C4.4,30.1,0,25.7,0,19.5C0,13.2,4.6,8.7,10.9,8.7c2.2,0,3.8,0.4,6.1,1.4l-1.7,4.3 c-1.5-0.6-2.5-0.9-3.8-0.9c-3.4,0-6,2-6,6c0,4,2.6,6,6.1,6c1.3,0,2.4-0.3,3.8-1.1l1.8,3.8C14.9,29.5,12.9,30.1,10.4,30.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCegidLogoBlue);
export default __webpack_public_path__ + "static/media/cegid-logo-blue.6ab2ad984776ce134705a68394601631.svg";
export { ForwardRef as ReactComponent };